export const Tr069DeviceConstants = {
  GET_DEVICE_REQUEST: "GET_TR069_DEVICE_REQUEST",
  GET_DEVICE_SUCCESS: "GET_TR069_DEVICE_SUCCESS",
  GET_DEVICE_FAILURE: "GET_TR069_DEVICE_FAILURE",
  LINK_DEVICE_REQUEST: "LINK_TR069_DEVICE_REQUEST",
  LINK_DEVICE_SUCCESS: "LINK_TR069_DEVICE_SUCCESS",
  LINK_DEVICE_FAILURE: "LINK_TR069_DEVICE_FAILURE",
  UNLINK_DEVICE_REQUEST: "UNLINK_TR069_DEVICE_REQUEST",
  UNLINK_DEVICE_SUCCESS: "UNLINK_TR069_DEVICE_SUCCESS",
  UNLINK_DEVICE_FAILURE: "UNLINK_TR069_DEVICE_FAILURE",
  GET_DEVICE_TASKS_REQUEST: "GET_TR069_DEVICE_TASKS_REQUEST",
  GET_DEVICE_TASKS_SUCCESS: "GET_TR069_DEVICE_TASKS_SUCCESS",
  GET_DEVICE_TASKS_FAILURE: "GET_TR069_DEVICE_TASKS_FAILURE",
  CREATE_TASK_REQUEST: "CREATE_TR069_TASK_REQUEST",
  CREATE_TASK_SUCCESS: "CREATE_TR069_TASK_SUCCESS",
  CREATE_TASK_FAILURE: "CREATE_TR069_TASK_FAILURE",
};
